import { api } from "./dataService";

/**
 * Objekte des Kunden dieses Bankkontos, je mit "assigned"-Flag.
 *
 * @param {number|string} bankAccountId
 * @returns {Promise<{objects: Array}>}
 */
export const getBankAccountObjectAssignments = async (bankAccountId) => {
  const response = await api.get(
    `data/bank-accounts/${bankAccountId}/object-assignments`
  );
  return response.data.data;
};

/**
 * Voller Sync der Objekt-Zuweisung (Mehrauswahl-Dialog).
 *
 * @param {number|string} bankAccountId
 * @param {number[]} objektIds
 * @returns {Promise<{objects: Array}>}
 */
export const updateBankAccountObjectAssignments = async (
  bankAccountId,
  objektIds
) => {
  const response = await api.put(
    `data/bank-accounts/${bankAccountId}/object-assignments`,
    { objekt_ids: objektIds }
  );
  return response.data.data;
};

/**
 * Liest die Header-Zeile einer hochgeladenen Datei aus und liefert einen
 * Mapping-Vorschlag (Spaltenindex je Feld: plz/ort/strasse/hausnr/
 * customer_reference_number), den der Nutzer vor der eigentlichen Vorschau
 * anpassen kann.
 *
 * @param {number|string} bankAccountId
 * @param {File} file
 * @returns {Promise<{columns: string[], suggested_mapping: {plz: ?number, ort: ?number, strasse: ?number, hausnr: ?number, customer_reference_number: ?number}}>}
 */
export const getBankAccountObjectImportColumns = async (
  bankAccountId,
  file
) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post(
    `data/bank-accounts/${bankAccountId}/object-assignments/import/columns`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data.data;
};

/**
 * Excel-Import (Vorschau oder Übernahme) für ein einzelnes Bankkonto.
 *
 * @param {number|string} bankAccountId
 * @param {File} file
 * @param {{dryRun: boolean, deleteRemoved: boolean, columnMapping: {plz: ?number, ort: ?number, strasse: ?number, hausnr: ?number, customer_reference_number: ?number}}} options
 *        columnMapping-Felder mit Wert null/undefined gelten als nicht zugeordnet und werden nicht mitgeschickt
 *        (mindestens Ref-ID oder die komplette Adresse muss gesetzt sein).
 * @returns {Promise<{to_add: Array, to_remove: Array, unchanged: Array, unmatched: Array, applied: boolean}>}
 */
export const importBankAccountObjectAssignments = async (
  bankAccountId,
  file,
  { dryRun, deleteRemoved, columnMapping }
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("dry_run", dryRun ? "1" : "0");
  formData.append("delete", deleteRemoved ? "1" : "0");
  Object.entries(columnMapping).forEach(([field, columnIndex]) => {
    if (columnIndex === null || columnIndex === undefined) return;
    formData.append(`column_mapping[${field}]`, columnIndex);
  });

  const response = await api.post(
    `data/bank-accounts/${bankAccountId}/object-assignments/import`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data.data;
};
